module.exports = __webpack_public_path__ + "static/media/Dr Jisha B.a4699773.webp";